/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Location_LabelInputs */



/**
* | output |
* | --- |
* | "Export Location:" |
*
* @param {Image_Export_Location_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_location_label = /** @type {((inputs?: Image_Export_Location_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Location_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Emplacement d'exportation :")
	if (locale === "de") return /** @type {LocalizedString} */ ("Exportort:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Posizione di esportazione:")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Место экспорта:")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ubicación de exportación:")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("出口地点：")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エクスポート場所:")
	if (locale === "hi") return /** @type {LocalizedString} */ ("निर्यात स्थान:")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Local de exportação:")
	return /** @type {LocalizedString} */ ("Export Location:")
});